import React, { useEffect, useState, Children, createElement, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Moon, Star, Heart, Book, Gift, Check, Quote, Sparkles, Leaf, Wind, AlertCircle, ChevronRight, Lock } from 'lucide-react';
// --- Meta Pixel Helper ---
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const initMetaPixel = () => {
  if (typeof window !== 'undefined' && !window.fbq) {
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Initialize with your Pixel ID
    window.fbq('init', '909578324763948');
  }
};
const trackPageView = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView');
  }
};
const trackAddToCart = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Duerme en 5 Minutos',
      content_type: 'product',
      value: 6.36,
      currency: 'USD'
    });
  }
};
// --- Animation Variants ---
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: 'easeOut'
    }
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const floatingStar = {
  animate: {
    y: [0, -10, 0],
    opacity: [0.4, 1, 0.4],
    transition: {
      duration: 3,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  }
};
// --- Sales Notification Data ---
const salesData = {
  names: [{
    name: 'María',
    city: 'Ciudad de México'
  }, {
    name: 'Ana',
    city: 'Buenos Aires'
  }, {
    name: 'Sofía',
    city: 'Bogotá'
  }, {
    name: 'Valentina',
    city: 'Lima'
  }, {
    name: 'Camila',
    city: 'Santiago'
  }, {
    name: 'Lucía',
    city: 'Madrid'
  }, {
    name: 'Isabella',
    city: 'Guadalajara'
  }, {
    name: 'Mariana',
    city: 'Medellín'
  }, {
    name: 'Gabriela',
    city: 'Caracas'
  }, {
    name: 'Paula',
    city: 'Monterrey'
  }, {
    name: 'Andrea',
    city: 'Quito'
  }, {
    name: 'Carmen',
    city: 'Barcelona'
  }, {
    name: 'Rosa',
    city: 'Miami'
  }, {
    name: 'Elena',
    city: 'Los Angeles'
  }, {
    name: 'Teresa',
    city: 'San Juan'
  }],
  product: 'Duerme en 5 Minutos',
  price: '$6.36',
  image: 'https://cdn.magicpatterns.com/uploads/dZtisnh2KzowdAstuyZBkL/ebooks.png'
};
const MobileSalesNotification = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentSale, setCurrentSale] = useState(() => {
    const randomIndex = Math.floor(Math.random() * salesData.names.length);
    return salesData.names[randomIndex];
  });
  useEffect(() => {
    const showNotification = () => {
      // Randomize the sale data
      const randomIndex = Math.floor(Math.random() * salesData.names.length);
      setCurrentSale(salesData.names[randomIndex]);
      setIsVisible(true);
      // Hide after 3 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 3000);
    };
    // Show first notification after 2 seconds
    const initialTimeout = setTimeout(showNotification, 2000);
    // Then loop: 3s visible + 5s hidden = 8s cycle
    const interval = setInterval(showNotification, 8000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <div className="md:hidden fixed bottom-6 left-4 right-4 z-50 pointer-events-none" data-id="element-1">
      <AnimatePresence data-id="element-2">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1,
        transition: {
          type: 'spring',
          stiffness: 400,
          damping: 25
        }
      }} exit={{
        opacity: 0,
        y: 20,
        transition: {
          duration: 0.3,
          ease: 'easeOut'
        }
      }} className="mx-auto max-w-sm pointer-events-auto" data-id="element-3">
            <div className="flex items-center gap-3 p-3 rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.3)] border border-white/10" style={{
          background: 'rgba(30, 30, 40, 0.85)',
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)'
        }} data-id="element-4">
              {/* Product Image */}
              <div className="flex-shrink-0 w-12 h-12 rounded-xl overflow-hidden bg-[#16213e]" data-id="element-5">
                <img src={salesData.image} alt={salesData.product} className="w-full h-full object-cover" data-id="element-6" />
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0" data-id="element-7">
                <p className="text-[#f5e6d3] text-sm font-medium truncate" data-id="element-8">
                  {currentSale.name} de {currentSale.city}
                </p>
                <p className="text-[#d4a574]/80 text-xs truncate" data-id="element-9">
                  compró{' '}
                  <span className="text-[#f5e6d3] font-medium" data-id="element-10">
                    {salesData.product}
                  </span>
                </p>
                <p className="text-[#c9a227] text-sm font-bold mt-0.5" data-id="element-11">
                  {salesData.price} USD
                </p>
              </div>

              {/* Time indicator */}
              <div className="flex-shrink-0 text-[#d4a574]/50 text-xs" data-id="element-12">
                ahora
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
// --- Components ---
const StarBackground = () => <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-13">
    {[...Array(20)].map((_, i) => <motion.div key={i} className="absolute text-[#d4a574]" initial={{
    x: Math.random() * 100 + '%',
    y: Math.random() * 100 + '%',
    scale: Math.random() * 0.5 + 0.5
  }} variants={floatingStar} animate="animate" style={{
    left: `${Math.random() * 100}%`,
    top: `${Math.random() * 100}%`,
    animationDelay: `${Math.random() * 5}s`
  }} data-id="element-14">
        <Star size={Math.random() * 10 + 5} fill="currentColor" className="opacity-30" data-id="element-15" />
      </motion.div>)}
  </div>;
const Section = ({
  children,
  className = '',
  id = ''
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => <motion.section id={id} initial="hidden" whileInView="visible" viewport={{
  once: true,
  margin: '-100px'
}} variants={fadeIn} className={`relative py-16 md:py-24 px-4 md:px-8 overflow-hidden ${className}`} data-id="element-16">
    {children}
  </motion.section>;
const PrimaryButton = ({
  children,
  className = '',
  onClick,
  href,
  trackAddToCartEvent = false
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
  trackAddToCartEvent?: boolean;
}) => {
  const handleClick = () => {
    if (trackAddToCartEvent) {
      trackAddToCart();
    }
    if (href) {
      window.open(href, '_blank');
    } else if (onClick) {
      onClick();
    }
  };
  return <motion.button onClick={handleClick} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`bg-[#c9a227] hover:bg-[#d4a574] text-[#1a1a2e] font-serif font-bold py-4 px-8 rounded-full text-lg md:text-xl shadow-[0_0_20px_rgba(201,162,39,0.3)] transition-all duration-300 flex items-center justify-center gap-2 mx-auto ${className}`} data-id="element-17">
      {children}
    </motion.button>;
};
export function LandingPage() {
  // Initialize Meta Pixel and track PageView on mount
  useEffect(() => {
    initMetaPixel();
    // Small delay to ensure pixel is loaded
    const timer = setTimeout(() => {
      trackPageView();
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  return <div className="min-h-screen bg-[#1a1a2e] text-[#f5e6d3] font-sans selection:bg-[#c9a227] selection:text-[#1a1a2e]" data-id="element-18">
      {/* Mobile Sales Notification */}
      <MobileSalesNotification data-id="element-19" />

      {/* 1. HERO SECTION */}
      <div className="relative min-h-screen flex flex-col items-center justify-center text-center px-4 pt-12 pb-20 bg-gradient-to-b from-[#1a1a2e] to-[#16213e]" data-id="element-20">
        <StarBackground data-id="element-21" />

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1
      }} className="z-10 max-w-4xl mx-auto" data-id="element-22">
          <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          delay: 0.2,
          duration: 0.8
        }} className="mb-6 inline-block" data-id="element-23">
            <span className="px-4 py-1 rounded-full border border-[#d4a574]/30 text-[#d4a574] text-sm tracking-widest uppercase bg-[#1a1a2e]/50 backdrop-blur-sm" data-id="element-24">
              Para mujeres que necesitan descansar
            </span>
          </motion.div>

          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl font-bold text-[#f5e6d3] mb-4 leading-tight" data-id="element-25">
            DUERME EN <br data-id="element-26" />
            <span className="text-[#c9a227]" data-id="element-27">5 MINUTOS</span>
          </h1>

          <p className="font-serif text-xl md:text-2xl text-[#d4a574] mb-8 max-w-2xl mx-auto italic" data-id="element-28">
            Los 7 Remedios de Abuelita y los Secretos Prohibidos que Apagan tu
            Insomnio
          </p>

          <motion.div className="relative w-full max-w-3xl mx-auto mb-12" whileHover={{
          scale: 1.02
        }} transition={{
          type: 'spring',
          stiffness: 300
        }} data-id="element-29">
            <div className="absolute inset-0 bg-[#c9a227]/20 blur-3xl rounded-full transform scale-75" data-id="element-30"></div>
            <img src="https://cdn.magicpatterns.com/uploads/dZtisnh2KzowdAstuyZBkL/ebooks.png" alt="Duerme en 5 Minutos eBook Mockup" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-31" />
          </motion.div>

          <PrimaryButton onClick={() => document.getElementById('oferta')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-32">
            Quiero Dormir Esta Noche <ChevronRight size={24} data-id="element-33" />
          </PrimaryButton>

          <p className="mt-4 text-sm text-[#d4a574]/60" data-id="element-34">
            <Lock size={12} className="inline mr-1" data-id="element-35" /> Pago seguro y descarga
            inmediata
          </p>
        </motion.div>
      </div>

      {/* 2. PAIN SECTION */}
      <Section className="bg-[#16213e]" data-id="element-36">
        <div className="max-w-3xl mx-auto text-center" data-id="element-37">
          <motion.div variants={fadeIn} data-id="element-38">
            <h2 className="font-serif text-3xl md:text-5xl text-[#f5e6d3] mb-8" data-id="element-39">
              ¿Hace cuánto no duermes de verdad?
            </h2>
            <p className="text-lg md:text-xl text-[#d4a574]/90 leading-relaxed mb-8" data-id="element-40">
              No hablo de cerrar los ojos unas horas y sobrevivir al día
              siguiente con café y cansancio. Hablo de dormir profundo. De ese
              descanso que te devuelve la vida, la alegría y la paz.
            </p>
            <p className="text-lg md:text-xl text-[#f5e6d3] leading-relaxed mb-12" data-id="element-41">
              Dormir como cuando eras niña. Cuando el cuerpo se rendía sin
              resistencia, y el alma flotaba tranquila entre sueños.
            </p>
          </motion.div>

          <motion.div variants={fadeIn} className="bg-[#1a1a2e]/50 p-8 rounded-2xl border border-[#d4a574]/20 mb-12 backdrop-blur-sm" data-id="element-42">
            <Quote className="text-[#c9a227] w-8 h-8 mx-auto mb-4 opacity-50" data-id="element-43" />
            <p className="font-serif text-2xl md:text-3xl italic text-[#f5e6d3] mb-4" data-id="element-44">
              "Estoy cansada de estar cansada"
            </p>
            <p className="text-[#d4a574]" data-id="element-45">
              Esa frase silenciosa que repites cada mañana frente al espejo.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left" data-id="element-46">
            {['Pastillas que te dejan aturdida todo el día', 'Tés naturales que ayudan una vez y luego nunca más', 'Videos de relajación que te ponen más nerviosa', 'Apps de meditación que te piden demasiado tiempo'].map((item, i) => <motion.div key={i} variants={fadeIn} className="flex items-start gap-3 p-4 bg-[#1a1a2e] rounded-lg border border-[#d4a574]/10" data-id="element-47">
                <AlertCircle className="text-[#c9a227] shrink-0 mt-1" size={20} data-id="element-48" />
                <span className="text-[#d4a574]" data-id="element-49">{item}</span>
              </motion.div>)}
          </div>
        </div>
      </Section>

      {/* 3. THE PROBLEM */}
      <Section className="bg-[#0f3460]" data-id="element-50">
        <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-51">
          <motion.div variants={fadeIn} data-id="element-52">
            <div className="inline-block p-3 rounded-full bg-[#c9a227]/10 mb-6" data-id="element-53">
              <Sparkles className="text-[#c9a227] w-8 h-8" data-id="element-54" />
            </div>
            <h2 className="font-serif text-3xl md:text-4xl text-[#f5e6d3] mb-6" data-id="element-55">
              El error que nadie te dijo
            </h2>
            <p className="text-[#d4a574]/90 mb-4 leading-relaxed" data-id="element-56">
              Durante años te han hecho creer que el insomnio es un fallo
              físico. Pero el cuerpo no es el problema.
            </p>
            <p className="text-[#f5e6d3] text-lg font-medium mb-4" data-id="element-57">
              El verdadero desajuste está en tu energía.
            </p>
            <p className="text-[#d4a574]/90 leading-relaxed" data-id="element-58">
              Tu mente repite pensamientos, preocupaciones, culpas. Tu energía
              está en modo defensa, y eso bloquea el descanso. Es como si dentro
              de ti hubiera una luz encendida toda la noche.
            </p>
          </motion.div>
          <motion.div variants={fadeIn} className="relative h-64 md:h-96 bg-gradient-to-br from-[#1a1a2e] to-[#16213e] rounded-full flex items-center justify-center shadow-[0_0_50px_rgba(201,162,39,0.1)]" data-id="element-59">
            <div className="absolute inset-0 rounded-full border border-[#d4a574]/20 animate-pulse" data-id="element-60"></div>
            <Moon className="w-32 h-32 text-[#f5e6d3] drop-shadow-[0_0_30px_rgba(245,230,211,0.5)]" data-id="element-61" />
            <div className="absolute bottom-10 text-center w-full" data-id="element-62">
              <span className="text-sm uppercase tracking-widest text-[#d4a574]" data-id="element-63">
                Modo Alerta
              </span>
            </div>
          </motion.div>
        </div>
      </Section>

      {/* 4. DOÑA TERESA'S STORY */}
      <Section className="bg-[#1a1a2e]" data-id="element-64">
        <div className="max-w-5xl mx-auto" data-id="element-65">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-66">
            <motion.div variants={fadeIn} className="order-2 md:order-1" data-id="element-67">
              <img src="https://cdn.magicpatterns.com/uploads/qvu6Q8b9qC9X8pxp5H4vy4/Libro_en_cama.png" alt="Libro en cama" className="rounded-lg shadow-2xl border border-[#d4a574]/20" data-id="element-68" />
            </motion.div>
            <motion.div variants={fadeIn} className="order-1 md:order-2" data-id="element-69">
              <h2 className="font-serif text-3xl md:text-4xl text-[#c9a227] mb-6" data-id="element-70">
                El secreto que nuestras abuelas sí conocían
              </h2>
              <p className="text-[#d4a574]/90 mb-6 leading-relaxed" data-id="element-71">
                Antes de que existieran los relojes inteligentes, Doña Teresa,
                una mujer sabia de los Andes, sabía cómo calmar el alma para que
                el cuerpo descansara.
              </p>
              <div className="bg-[#16213e] p-6 rounded-xl border-l-4 border-[#c9a227] mb-6" data-id="element-72">
                <p className="font-serif italic text-xl text-[#f5e6d3]" data-id="element-73">
                  "El alma cansada no duerme. Primero hay que calmarla."
                </p>
              </div>
              <p className="text-[#d4a574]/90 leading-relaxed" data-id="element-74">
                Su nieta encontró sus viejos cuadernos llenos de fórmulas y
                oraciones. Probó los rituales y esa noche durmió como no lo
                hacía en años.
              </p>
            </motion.div>
          </div>
        </div>
      </Section>

      {/* 5. THE 7 REMEDIES */}
      <Section className="bg-[#16213e]" data-id="element-75">
        <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-76">
          <h2 className="font-serif text-3xl md:text-5xl text-[#f5e6d3] mb-6" data-id="element-77">
            Los 7 Remedios de Abuelita
          </h2>
          <p className="text-lg text-[#d4a574]" data-id="element-78">
            El Mecanismo de Calma Ancestral: ciencia y espiritualidad unidas.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-79">
          {[{
          icon: <Leaf className="w-8 h-8" data-id="element-80" />,
          title: 'Hierbas Medicinales',
          desc: 'Relajan el sistema nervioso naturalmente sin químicos.'
        }, {
          icon: <Moon className="w-8 h-8" data-id="element-81" />,
          title: 'Rituales Energéticos',
          desc: 'Equilibran tu frecuencia y bajan la alerta mental.'
        }, {
          icon: <Wind className="w-8 h-8" data-id="element-82" />,
          title: 'Respiración Profunda',
          desc: 'Enseñan al cuerpo a soltar el control y rendirse al sueño.'
        }].map((item, i) => <motion.div key={i} variants={fadeIn} whileHover={{
          y: -10
        }} className="bg-[#1a1a2e] p-8 rounded-2xl border border-[#d4a574]/10 text-center hover:border-[#c9a227]/50 transition-colors" data-id="element-83">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#c9a227]/10 text-[#c9a227] mb-6" data-id="element-84">
                {item.icon}
              </div>
              <h3 className="font-serif text-xl text-[#f5e6d3] mb-4" data-id="element-85">
                {item.title}
              </h3>
              <p className="text-[#d4a574]/80" data-id="element-86">{item.desc}</p>
            </motion.div>)}
        </div>
      </Section>

      {/* 6. CHAPTER LIST */}
      <Section className="bg-[#1a1a2e]" data-id="element-87">
        <div className="max-w-4xl mx-auto" data-id="element-88">
          <div className="text-center mb-12" data-id="element-89">
            <Book className="w-12 h-12 text-[#c9a227] mx-auto mb-4" data-id="element-90" />
            <h2 className="font-serif text-3xl md:text-4xl text-[#f5e6d3]" data-id="element-91">
              Lo que encontrarás dentro
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-4" data-id="element-92">
            {['El problema del insomnio en el siglo XXI', 'El secreto de la abuela: 7 remedios caseros', 'El bálsamo secreto que apaga el insomnio', 'El truco prohibido para dormir al instante', 'Sueño express: La ciencia de la siesta', 'La ciencia del sueño y la neurociencia', 'Comparativa: Remedios vs. pastillas', 'Historias de éxito reales', 'Guía paso a paso: De la vigilia al sueño', 'Tu plan de acción en 7 días', 'Preguntas frecuentes', 'Conclusión y despedida'].map((chapter, i) => <motion.div key={i} variants={fadeIn} className="flex items-center gap-4 p-4 bg-[#16213e] rounded-lg border border-[#d4a574]/5 hover:bg-[#1f2b4d] transition-colors" data-id="element-93">
                <span className="flex-shrink-0 w-8 h-8 rounded-full bg-[#c9a227]/20 text-[#c9a227] flex items-center justify-center font-serif font-bold text-sm" data-id="element-94">
                  {i + 1}
                </span>
                <span className="text-[#f5e6d3]" data-id="element-95">{chapter}</span>
              </motion.div>)}
          </div>
        </div>
      </Section>

      {/* 7. BONUSES */}
      <Section className="bg-gradient-to-b from-[#16213e] to-[#0f3460]" data-id="element-96">
        <div className="max-w-5xl mx-auto" data-id="element-97">
          <motion.div variants={fadeIn} className="text-center mb-16" data-id="element-98">
            <span className="text-[#c9a227] tracking-widest uppercase font-bold text-sm mb-2 block" data-id="element-99">
              Regalos Exclusivos
            </span>
            <h2 className="font-serif text-3xl md:text-5xl text-[#f5e6d3]" data-id="element-100">
              Bonus Especiales Incluidos
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-101">
            {[{
            title: 'Sueño Profundo con Aromaterapia',
            subtitle: 'PDF Extra',
            desc: 'Usa el poder de las plantas y aromas para inducir sueño profundo.',
            image: 'https://cdn.magicpatterns.com/uploads/5cpB8g9rGaEWSa94KDAn2Z/Bonus_1.png'
          }, {
            title: 'Diario Nocturno de Liberación Mental',
            subtitle: 'PDF Imprimible',
            desc: 'Vacía tu mente de preocupaciones antes de tocar la almohada.',
            image: 'https://cdn.magicpatterns.com/uploads/dAX7QFNNNJkwjoCjAfSSfT/Bonus_2.png'
          }, {
            title: 'Ritual de Gratitud Nocturna',
            subtitle: 'Plantilla Paso a Paso',
            desc: 'El antídoto natural contra la ansiedad nocturna.',
            image: 'https://cdn.magicpatterns.com/uploads/mNAb5Hb2P73gwrFuZNUDaA/Bonus_3.png'
          }].map((bonus, i) => <motion.div key={i} variants={fadeIn} whileHover={{
            y: -8
          }} className="bg-[#1a1a2e] rounded-2xl border border-[#c9a227]/30 relative overflow-hidden group" data-id="element-102">
                <div className="absolute top-3 right-3 z-10 bg-[#c9a227] text-[#1a1a2e] text-xs font-bold px-3 py-1 rounded-full shadow-lg" data-id="element-103">
                  GRATIS
                </div>
                <div className="relative overflow-hidden" data-id="element-104">
                  <img src={bonus.image} alt={bonus.title} className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a2e] via-transparent to-transparent opacity-60" data-id="element-106"></div>
                </div>
                <div className="p-6" data-id="element-107">
                  <h3 className="font-serif text-lg text-[#f5e6d3] mb-1" data-id="element-108">
                    {bonus.title}
                  </h3>
                  <p className="text-xs text-[#c9a227] uppercase tracking-wider mb-3" data-id="element-109">
                    {bonus.subtitle}
                  </p>
                  <p className="text-[#d4a574]/80 text-sm leading-relaxed" data-id="element-110">
                    {bonus.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </Section>

      {/* 8. TESTIMONIALS */}
      <Section className="bg-[#1a1a2e]" data-id="element-111">
        <h2 className="font-serif text-3xl md:text-4xl text-center text-[#f5e6d3] mb-16" data-id="element-112">
          Lo que dicen quienes ya lo vivieron
        </h2>
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-113">
          {[{
          text: 'Llevaba meses sin dormir bien. El primer día que hice el ritual #3 dormí toda la noche. No podía creerlo.',
          author: 'María, 42 años',
          loc: 'Colombia'
        }, {
          text: 'Pensé que era otro libro de remedios, pero es más que eso. Es una experiencia. Ahora duermo, pero también me siento en paz.',
          author: 'Claudia, 37 años',
          loc: 'México'
        }, {
          text: 'Mi mamá decía que la lavanda era mágica. Ahora entiendo por qué. He recuperado mi energía.',
          author: 'Patricia, 54 años',
          loc: 'Chile'
        }].map((t, i) => <motion.div key={i} variants={fadeIn} className="bg-[#16213e] p-8 rounded-xl relative" data-id="element-114">
              <Quote className="absolute top-4 right-4 text-[#c9a227]/20 w-8 h-8" data-id="element-115" />
              <div className="flex gap-1 text-[#c9a227] mb-4" data-id="element-116">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-117" />)}
              </div>
              <p className="text-[#f5e6d3] italic mb-6" data-id="element-118">"{t.text}"</p>
              <div data-id="element-119">
                <p className="font-bold text-[#d4a574]" data-id="element-120">{t.author}</p>
                <p className="text-xs text-[#f5e6d3]/50" data-id="element-121">{t.loc}</p>
              </div>
            </motion.div>)}
        </div>
      </Section>

      {/* 9. SCIENCE */}
      <Section className="bg-[#0f3460] text-center" data-id="element-122">
        <div className="max-w-3xl mx-auto" data-id="element-123">
          <h2 className="font-serif text-3xl md:text-4xl text-[#f5e6d3] mb-8" data-id="element-124">
            ¿Por qué este método funciona tan rápido?
          </h2>
          <p className="text-lg text-[#d4a574]/90 mb-8 leading-relaxed" data-id="element-125">
            No lucha contra tu insomnio… lo desactiva desde su raíz. El
            Mecanismo de Calma Ancestral activa una respuesta biológica natural
            llamada
            <span className="text-[#c9a227] font-bold" data-id="element-126">
              {' '}
              "modo parasimpático"
            </span>
            , el sistema del descanso profundo.
          </p>
          <div className="p-6 bg-[#1a1a2e]/50 rounded-xl border border-[#d4a574]/20 inline-block" data-id="element-127">
            <p className="text-[#f5e6d3]" data-id="element-128">
              En minutos, tu cerebro pasa del modo{' '}
              <span className="text-red-400" data-id="element-129">"alerta"</span> al modo{' '}
              <span className="text-green-400" data-id="element-130">"curación"</span>.
            </p>
          </div>
        </div>
      </Section>

      {/* 10. PRICING / CTA */}
      <Section id="oferta" className="bg-[#1a1a2e] py-24" data-id="element-131">
        <div className="max-w-4xl mx-auto bg-gradient-to-br from-[#16213e] to-[#0f3460] rounded-3xl p-8 md:p-12 shadow-2xl border border-[#c9a227]/30 text-center relative overflow-hidden" data-id="element-132">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#1a1a2e] via-[#c9a227] to-[#1a1a2e]" data-id="element-133"></div>

          <motion.div animate={{
          scale: [1, 1.05, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} className="inline-block bg-[#c9a227] text-[#1a1a2e] font-bold px-4 py-1 rounded-full text-sm mb-6" data-id="element-134">
            OFERTA ESPECIAL DE LANZAMIENTO
          </motion.div>

          <h2 className="font-serif text-4xl md:text-5xl text-[#f5e6d3] mb-4" data-id="element-135">
            Recupera tus noches hoy mismo
          </h2>
          <p className="text-[#d4a574] mb-8 max-w-xl mx-auto" data-id="element-136">
            Por menos de lo que cuesta una caja de pastillas, recibe una guía
            completa, natural y eterna.
          </p>

          <div className="flex items-center justify-center gap-4 mb-8" data-id="element-137">
            <span className="text-[#f5e6d3]/40 text-2xl line-through" data-id="element-138">
              $27.00
            </span>
            <span className="text-[#c9a227] text-6xl font-serif font-bold" data-id="element-139">
              $6.36
            </span>
            <span className="text-[#f5e6d3] text-xl" data-id="element-140">USD</span>
          </div>

          <PrimaryButton href="https://almadigitalebooks.digital/cart/42662254870646:1" className="w-full md:w-auto px-12 py-5 text-xl mb-6" trackAddToCartEvent={true} data-id="element-141">
            Descargar Mi Copia Ahora <Gift className="ml-2" data-id="element-142" />
          </PrimaryButton>

          <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-sm text-[#d4a574]/70" data-id="element-143">
            <span className="flex items-center gap-1" data-id="element-144">
              <Check size={16} data-id="element-145" /> Acceso Inmediato
            </span>
            <span className="flex items-center gap-1" data-id="element-146">
              <Check size={16} data-id="element-147" /> Compra Segura
            </span>
            <span className="flex items-center gap-1" data-id="element-148">
              <Check size={16} data-id="element-149" /> Garantía de Satisfacción
            </span>
          </div>
        </div>
      </Section>

      {/* 11. FINAL CLOSE */}
      <Section className="bg-[#1a1a2e] text-center pb-32" data-id="element-150">
        <div className="max-w-2xl mx-auto" data-id="element-151">
          <Heart className="w-12 h-12 text-[#c9a227] mx-auto mb-6 animate-pulse" data-id="element-152" />
          <h2 className="font-serif text-3xl text-[#f5e6d3] mb-6" data-id="element-153">
            Esta noche puede ser el inicio de algo sagrado
          </h2>
          <p className="text-[#d4a574]/80 mb-8 leading-relaxed" data-id="element-154">
            Volver a escuchar el silencio interior. Volver a confiar en tu
            propio ritmo. Volver a dormir… con el alma.
          </p>
          <p className="font-serif italic text-xl text-[#f5e6d3] mb-12" data-id="element-155">
            Con amor y calma,
            <br data-id="element-156" />
            El equipo de "Duerme en 5 Minutos"
          </p>

          <div className="text-xs text-[#f5e6d3]/30" data-id="element-157">
            © 2024 Duerme en 5 Minutos. Todos los derechos reservados.
          </div>
        </div>
      </Section>
    </div>;
}